import '@stoplight/elements-core/styles.min.css';
import { API } from '@stoplight/elements';
import { Box } from '@stoplight/mosaic';
import React, { useContext } from 'react';
import { GlobalContext } from '../context';
export const ElementsAPI = () => {
    const { apiDescriptionUrl, layout } = useContext(GlobalContext);
    const specUrlWithProxy = apiDescriptionUrl && window.location.origin === 'https://elements-demo.stoplight.io'
        ? `https://stoplight.io/cors-proxy/${apiDescriptionUrl}`
        : apiDescriptionUrl;
    return (React.createElement(Box, { flex: 1, overflowY: layout !== 'stacked' ? 'hidden' : undefined },
        React.createElement(API, { key: specUrlWithProxy, apiDescriptionUrl: specUrlWithProxy, router: "history", layout: layout, hideSchemas: true })));
};
